import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const ArrowDownIcon: FC<ISvgProps> = ({ primaryColor = '#535763' }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 8.75784L11.8891 5.22223L13 6.2322L8 10.7778L3 6.2322L4.11094 5.22223L8 8.75784Z"
				fill={primaryColor}
			/>
		</svg>
	);
};
